
const Cargos = {
    UNITS: {
        CM: 1,
        M: 2,
        KG: 1,
        T: 2,
    },
    ATTRIBUTE_NAME: 23,
    ATTRIBUTE_VOLUME: 5,
    ATTRIBUTE_LENGTH: 2,
    ATTRIBUTE_WIDTH: 3,
    ATTRIBUTE_HEIGHT: 4,
    ATTRIBUTE_WEIGHT: 6,
    ATTRIBUTE_UNITS: 7,
    ATTRIBUTE_QUANTITY: 1,
    ATTRIBUTE_NOT_FIT_ELEVATOR: 10,
};

export default Cargos



// WEBPACK FOOTER //
// ./client/constants/Cargos.js